module.exports = __webpack_public_path__ + "static/media/33-8.aac3500b.mp3";